import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';

import { formatDate, currencyFormat, isValidDate } from 'utilities/common';
import { useSelector } from 'react-redux';

export const FormRouting = ({ type, originalData, onChanges, onDelete }) => {
  const StateForm = useSelector((state) => state?.Form);
  const [data, setData] = React.useState(false);

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragEnd = async (result) => {
    if (!result?.destination) {
      return;
    }

    const items = reorder(
      data,
      result?.source?.index,
      result?.destination?.index
    );

    setData(items);
    onChanges(items);
  };

  const onRemove = async (index) => {
    if (!data) {
      return;
    }

    let idx = data
      ?.map((x) => {
        return x?.id;
      })
      .indexOf(index);

    if (idx > -1) {
      data?.splice(idx, 1);
    }

    onDelete(data);
  };

  React.useEffect(() => {
    setData(originalData);
  }, [originalData]);

  if (!data || !type || data?.length === 0) {
    return (
      <div className="bg-white p-4 text-center border" id="routing">
        <h3>Silakan pilih shipment yang akan didispatch</h3>
      </div>
    );
  }

  return (
    <div className="bg-white" id="routing">
      <div
        className=""
        id="routing"
        style={{ maxHeight: 400, overflow: 'auto' }}
      >
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <div className="table-responsive m-0 ">
                <table
                  width="100%"
                  className={cn(
                    'table table-hover table-vcenter card-table  datatable border',
                    snapshot.isDraggingOver && 'draggingOver'
                  )}
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                >
                  <thead className="bg-light">
                    <tr className="th">
                      <td></td>
                      <td>No</td>
                      {type === 'pickup' ? (
                        <>
                          <td style={{ whiteSpace: 'initial', width: '200px' }}>
                            Pickup
                          </td>
                          <td style={{ whiteSpace: 'initial', width: '200px' }}>
                            Shipment
                          </td>
                        </>
                      ) : (
                        <td style={{ whiteSpace: 'initial', width: '400px' }}>
                          Destination
                        </td>
                      )}
                      <td style={{ width: '100px' }}>Muatan</td>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((item, index) => (
                      <Draggable
                        key={item?.id}
                        draggableId={`${item?.id}-id`}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <tr
                            className={cn(
                              'item bg-white',
                              snapshot.isDragging && 'dragging',
                              StateForm?.errors[`jobs.${index}.job_id`]
                                ? 'text-danger border-danger'
                                : null
                            )}
                            style={provided.draggableProps.style}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <td>
                              <div
                                className="btn btn-danger px-2"
                                onClick={() => onRemove(item?.id)}
                              >
                                <Fi.FiTrash2 size="13" />
                              </div>
                            </td>
                            <td>{index + 1}</td>

                            {type === 'pickup' ? (
                              <>
                                <td
                                  style={{
                                    whiteSpace: 'initial',
                                    width: '400px',
                                  }}
                                >
                                  <div className="table-col">
                                    <small className="text-ellipsis d-block">
                                      {item?.delivery_order?.order?.code}
                                    </small>
                                    <div className="text-ellipsis fw-semibold text-uppercase">
                                      {item?.origin?.name}
                                    </div>
                                    <small className="text-ellipsis text-uppercase d-block fw-semibold">
                                      {
                                        item?.delivery_order?.order?.customer
                                          ?.name
                                      }
                                    </small>
                                    <small className="info text-uppercase">
                                      {item?.origin?.region?.district_name},{' '}
                                      {item?.origin?.region?.regency_name},{' '}
                                      {item?.origin?.region?.province_name}
                                    </small>
                                  </div>
                                  {
                                    StateForm?.errors[`jobs.${index}.job_id`] && (
                                      <div className="invalid-feedback d-block ">
                                        {StateForm?.errors[`jobs.${index}.job_id`]}
                                      </div>
                                    )
                                  }
                                </td>
                                <td
                                  style={{
                                    whiteSpace: 'initial',
                                    width: '400px',
                                  }}
                                >
                                  <div className="table-col">
                                    <small className="text-ellipsis d-block">
                                      {item?.delivery_order?.shipment?.code}
                                    </small>
                                    <div className="text-ellipsis fw-semibold d-block text-uppercase">
                                      {
                                        item?.delivery_order?.shipment
                                          ?.destination?.name
                                      }
                                    </div>
                                    <small className="info text-uppercase">
                                      {
                                        item?.delivery_order?.shipment
                                          ?.destination?.region?.district_name
                                      }
                                      ,{' '}
                                      {
                                        item?.delivery_order?.shipment
                                          ?.destination?.region?.regency_name
                                      }
                                      ,{' '}
                                      {
                                        item?.delivery_order?.shipment
                                          ?.destination?.region?.province_name
                                      }
                                    </small>
                                  </div>
                                </td>
                              </>
                            ) : type === 'console' ? (
                              <>
                                <td
                                  style={{
                                    whiteSpace: 'initial',
                                    width: '400px',
                                  }}
                                >
                                  <div className="table-col">
                                    <small className="text-ellipsis d-block">
                                      {item?.delivery_order?.shipment?.code}
                                    </small>
                                    <div className="text-ellipsis fw-semibold d-block text-uppercase">
                                      {
                                        item?.delivery_order?.shipment
                                          ?.destination?.name
                                      }
                                    </div>
                                    <small className="info text-uppercase">
                                      {
                                        item?.delivery_order?.shipment
                                          ?.destination?.region?.district_name
                                      }
                                      ,{' '}
                                      {
                                        item?.delivery_order?.shipment
                                          ?.destination?.region?.regency_name
                                      }
                                      ,{' '}
                                      {
                                        item?.delivery_order?.shipment
                                          ?.destination?.region?.province_name
                                      }
                                    </small>
                                  </div>
                                  {
                                    StateForm?.errors[`jobs.${index}.job_id`] && (
                                      <div className="invalid-feedback d-block ">
                                        {StateForm?.errors[`jobs.${index}.job_id`]}
                                      </div>
                                   )
                                  }
                                </td>
                              </>
                            ) : (
                              <td
                                style={{
                                  whiteSpace: 'initial',
                                  width: '400px',
                                }}
                              >
                                <div className="table-col">
                                  <small className="text-ellipsis d-block">
                                    {item?.delivery_order?.shipment?.code}
                                  </small>
                                  <div className="text-ellipsis fw-semibold text-uppercase">
                                    {item?.destination?.name}
                                  </div>
                                  <small className="info text-uppercase">
                                    {item?.destination?.region?.district_name},{' '}
                                    {item?.destination?.region?.regency_name},{' '}
                                    {item?.destination?.region?.province_name}
                                  </small>
                                  {isValidDate(
                                    item?.delivery_order?.shipment?.eta_at
                                  ) && (
                                    <small className="info text-warning text-uppercase">
                                      ETA:{' '}
                                      {formatDate(
                                        item?.delivery_order?.shipment?.eta_at
                                      )}
                                    </small>
                                  )}
                                </div>
                                {
                                  StateForm?.errors[`jobs.${index}.job_id`] && (
                                    <div className="invalid-feedback d-block ">
                                      {StateForm?.errors[`jobs.${index}.job_id`]}
                                    </div>
                                  )
                                }
                              </td>
                            )}

                            <td style={{ width: '100px' }}>
                              <div className="table-col">
                                <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
                                  {currencyFormat(
                                    item?.delivery_order?.shipment?.total_weight
                                  )}{' '}
                                  KG
                                </div>
                                <small className="info text-uppercase">
                                  {
                                    item?.delivery_order?.shipment
                                      ?.total_quantity
                                  }{' '}
                                  Koli
                                </small>
                              </div>
                            </td>
                          </tr>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </tbody>
                </table>
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </div>
  );
};
